export enum PitchListsRoutes {
  AddPitches = 'add-pitches',
  CopyMany = 'copy-many',
  CopyOne = 'copy-one',
  Create = 'create',
  DeleteMany = 'delete-many',
  GetHashSummaries = 'get-hash-summaries',
  GetOne = 'get-one',
  GetLiveReferences = 'get-live-references',
  GetVisible = 'get-visible',
  ImportCsv = 'import-csv',
  RenameFolder = 'rename-folder',
  Restore = 'restore',
  UpdateMany = 'update-many',
  UpdateOne = 'update-one',
}
